import {
  OrePagination,
  OreStack,
  OreTable,
  OreTableActions,
  OreTableBody,
  OreTableCaption,
  OreTableCell,
  OreTableContainer,
  OreTableHead,
  OreTableRow,
  OreText,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { useAccessRoles } from '@/AccessRoles/ui/hooks/useAccessRoles'
import { TableHeadersModel } from '@/Shared/domain/models/TableHeadersModel'
import { tablePagination } from '@/Shared/ui/sharedTranslation'
import { accessRolesTranslation } from '../AccesRolesTranslation'
import { AccessRolesRow } from '../molecules/AccessRolesRow'
import { AccessRolesModel } from '@/AccessRoles/domain'
import { Dispatch, SetStateAction } from 'react'
import { GroupType } from '@/partnersGroups/domain/ProfileTypes'

export const AccessRolesList = (props:{setRefresh: Dispatch<SetStateAction<number>>,
  groupType: GroupType
}): JSX.Element => {
  const { t } = useTranslation()
  const {
    profiles,
    count,
    onPageChange,
    page,
    numberOfRecordsPerPage,
    tableHeaders,
  } = useAccessRoles()

  return (
    <OreStack placeContent="stretch">
      <OreTableContainer>
        <OreTable>
          <OreTableCaption title={t(accessRolesTranslation.table.title)} />

          <OreTableHead valign="middle">
            <OreTableRow hover={false}>

              {tableHeaders.map((header: TableHeadersModel) => (
                <OreTableCell as="th" key={header.key} size={header.size}>
                  <span style={{ whiteSpace: 'pre-line', display: 'flex' }}>
                    {header.label && t(header.label)}
                  </span>
                </OreTableCell>
              ))}
            </OreTableRow>
          </OreTableHead>
          <OreTableBody valign="top">
            {profiles && profiles.length > 0
              ? profiles.map((profile: AccessRolesModel, index: number) => {
                return (
                  <AccessRolesRow
                    key={`p_${index}`}
                    profile={profile}
                    setRefresh={props.setRefresh}
                    groupType={props.groupType}
                  />
                )
              })
              :
                <OreTableRow>
                  <OreTableCell colSpan={7}>
                    <div className="p-05">
                      <OreText size="text-sm">
                        {t(accessRolesTranslation.table.noResults)}
                      </OreText>
                    </div>
                  </OreTableCell>
                </OreTableRow>}
          </OreTableBody>
        </OreTable>
        {count > 0 ? (
          <OreTableActions>
            <OrePagination
              displayPageButtons
              count={count}
              labelNextPage={t(tablePagination.nextPageLabel)}
              labelPreviousPage={t(tablePagination.previousPageLabel)}
              onPageChange={onPageChange}
              page={page}
              rowsPerPage={numberOfRecordsPerPage}
              text={t(tablePagination.pageOf)}
              legend={t(tablePagination.rowsShowing)}
            />
          </OreTableActions>
        ) : null}
      </OreTableContainer>

    </OreStack>
  )
}
